import {Component, EventEmitter, Input, OnChanges, Output, SimpleChange} from "@angular/core";
import {BaseDeterminantBuilder} from "../../core/base-determinant-builder/base-determinant-builder";

@Component({
  selector: "determinant-builder",
  templateUrl: "./determinant-builder.component.html",
})
export class DeterminantBuilderComponent extends BaseDeterminantBuilder implements OnChanges {

  @Input()
  public serviceId: string;

  @Input()
  public jsonString: string;

  @Input()
  public jsonLogic: string;

  @Input()
  public determinantValue: boolean;

  @Input()
  public showBehaviour: boolean = true;

  @Input()
  public noneSelectedText = "All";

  @Input()
  public showSaveCancelRow = true;

  @Input()
  public readonly = false;

  @Output()
  public onChange = new EventEmitter();

  @Output()
  public onSave = new EventEmitter();

  @Output()
  public onDeterminantValueSave = new EventEmitter();

  @Output()
  public onCancel = new EventEmitter();

  @Output()
  public askForEdit = new EventEmitter();

  private lastEvent: string;

  public ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes.jsonString && changes.jsonString.currentValue) {
      this.lastEvent = JSON.stringify(changes.jsonString.currentValue);
    }
  }

  public formChanged(event: any) {
    const newEvent = event.jsonString;
    if (newEvent !== this.lastEvent && this.lastEvent !== undefined) {
      this.lastEvent = newEvent;
      this.onChange.emit(event);
      if (this.showSaveCancelRow === false) {
        this.onSave.emit(event.groups);
      }
    } else if (this.lastEvent === undefined) {
      this.lastEvent = newEvent;
    }
  }


  _appendDeterminant = (det) =>  {
    this.jsonString = JSON.stringify(this.appendDeterminant(det, JSON.parse(this.jsonString)));
    this.onChange.emit({jsonString: this.jsonString});
  };

}
